<template>
  <div>

    <head>

      <meta charset="utf-8"/>
      <title>HRMS - Human Resource Management System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="HMIS By Craft Silicon Payments" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>


      <!-- owl.carousel css -->
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    </head>


    <body @contextmenu.prevent data-sidebar="dark">

    <!-- Begin page -->
    <div id="layout-wrapper">

      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">

        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Payroll Uploading</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Payroll Reconciliation</li>
                    <li class="breadcrumb-item active">Upload Payroll</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>


          <!-- end of stats -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex text-center align-items-center justify-content-center">
                    <div class="row d-flex text-center align-items-center justify-content-center initial-placeholder-receipting">
                      <div class="col-sm-12 col-lg-6 col-md-6">
                        <div class="p-4 border-radius border-solid border-primary border-2">
                          <div class="img mb-4 pt-3">
                            <img src="assets/AnimatedIcons/icons8-upload.gif" class="img"
                                 alt="">
                          </div>
                          <div>
                            <h4 class="card-title text-uppercase text-dark">Payroll Upload</h4>
                            <p>This section allows you to upload the monthly payroll Excel file
                              for reconciliation. Ensure the file is formatted correctly
                              before proceeding.</p>
                            <p class="fw-semibold text-capitalize">Upload the payroll file to
                              continue</p>

                            <!-- Hidden file input -->
                            <input type="file" id="payrollFileInput" style="display: none;"
                                   accept=".xlsx, .xls"/>

                            <!-- Upload button -->
                            <button type="button"
                                    class="btn btn-lg btn-primary btn-block w-100 mt-5 mb-3"
                                    data-bs-toggle="modal" data-bs-target="#payrollInfoModal"
                                    fdprocessedid="uploadPayroll">
                              <i class="bx bx-upload font-size-28 align-middle me-2"></i>
                              Upload Payroll File
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->


        <!-- Modal for Revenue and Month Selection -->
        <div class="modal fade" id="payrollInfoModal" tabindex="-1" aria-labelledby="payrollInfoModalLabel"
             aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="payrollInfoModalLabel">Payroll Information</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div v-if="!results" class="modal-body inputs-cont">
                <form id="payrollInfoForm">
                  <div class="mb-3">
                    <label for="revenueCollected" class="form-label">Revenue Collected</label>
                    <div class="input-group">
                      <span class="input-group-text">KSh</span>
                      <input type="number" class="form-control" id="revenueCollected"
                             placeholder="Enter amount" required>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="payrollMonth" class="form-label">Select Month</label>
                    <select class="form-select" id="payrollMonth" required>
                      <option value="" selected disabled>Choose month...</option>
                      <option value="january">January</option>
                      <option value="february">February</option>
                      <option value="march">March</option>
                      <option value="april">April</option>
                      <option value="may">May</option>
                      <option value="june">June</option>
                      <option value="july">July</option>
                      <option value="august">August</option>
                      <option value="september">September</option>
                      <option value="october">October</option>
                      <option value="november">November</option>
                      <option value="december">December</option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="payrollFileInput" class="form-label">Payroll File</label>
                    <input type="file" class="form-control" id="payrollFileInput" accept=".xlsx, .xls"
                           required>
                  </div>
                </form>

                <div class="col-12">
                  <button @click="uploadRecon()" class="btn btn-primary btn-100 w-100 submit-payrol">Submit</button>
                </div>
              </div>

              <div v-if="loading" class="modal-body loader">
                <div class="modal-loader">
                  <div class="d-flex justify-content-center align-items-center p-5">
                    <div class="img mb-4 pt-3">
                      <img src="assets/AnimatedIcons/icons8-search-in-list.gif" class="img"
                           alt="Success">
                    </div>

                    <div class="spinner-border text-primary m-1 d-none" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="results" class="modal-body text-center results">
                <div class="p-4 border-radius border-solid border-primary border-2">
                  <div class="img mb-4 pt-3">
                    <img src="assets/AnimatedIcons/icons8-paid-search-50.png" class="img" alt="Success">
                  </div>
                  <div>
                    <h4 class="card-title text-uppercase text-dark">Payroll Upload Successful</h4>
                    <p>The payroll report has been uploaded successfully. Below is a summary of the key
                      findings from the reconciliation process.</p>

                    <div class="alert alert-warning text-start">
                      <h5 class="text-uppercase fw-bold mb-1">Discrepancies Detected</h5>
                      <p class="mb-1">⚠️ <strong>15 discrepancies</strong> were identified compared to
                        current employee register</p>
                      <p class="mb-0">Last Month: <span class="fw-semibold">10 discrepancies</span>
                      </p>
                    </div>

                    <div class="alert alert-info text-start">
                      <h5 class="text-uppercase fw-bold mb-1">Employee Count</h5>
                      <p class="mb-1">👥 <strong class="text-danger">7,920 employees</strong> detected
                        in this upload.</p>
                      <p class="mb-0">Employee Register <span
                          class="fw-semibold">7,720 employees</span></p>
                    </div>

                    <div class="alert alert-primary text-start">
                      <h5 class="text-uppercase fw-bold mb-1">Wage Bill Comparison</h5>
                      <p class="mb-1">💰 Payroll Wage Bill: <strong>Ksh 15,000,000</strong></p>
                      <p class="mb-0">Employee Register Wage Bill: <span class="fw-semibold">Ksh 14,500,000</span>
                      </p>
                    </div>

                    <!-- Button to Review Detailed Discrepancies -->
                    <a data-bs-dismiss="modal" aria-label="Close" @click="gotTo('view_discrepancy')" type="button"
                       class="btn  btn-primary btn-block w-100 mt-5 mb-3">
                      <i class="bx bx-search-alt-2 font-size-28 align-middle me-2"></i>
                      Review Detailed Discrepancies
                    </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>


      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    </body>

  </div>
</template>

<script>

</script>

